import { defineStore } from 'pinia'

export const useHomeStore = defineStore('HomeStore', () => {
  const signIn = ref(true)
  return {
    signIn
  }
})
